// src/lib/resizeImage.js
//
// A picked image → a JPEG data URL bounded to maxWidth × maxHeight (aspect
// kept). Moved verbatim out of Studio's former collections page (031-01;
// that page was removed in 031-03); the post composer's ImageUpload uses it.

// ============================================
// IMAGE RESIZE UTILITY
// ============================================
export const resizeImage = (file, maxWidth = 1280, maxHeight = 720, quality = 0.85) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new window.Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const resizedReader = new FileReader();
              resizedReader.onloadend = () => resolve(resizedReader.result);
              resizedReader.onerror = reject;
              resizedReader.readAsDataURL(blob);
            } else {
              reject(new Error('Failed to create blob'));
            }
          },
          'image/jpeg',
          quality
        );
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export default resizeImage;
